<template>
  <div class="container" v-loading="loading">
        <div class="top-bar">
            <div class="left">
                <el-tabs v-model="active" @tab-click="tabChange" stretch>
                    <el-tab-pane
                    v-for="(item, idx) in tabList"
                    :key="idx"
                    :label="item.title"
                    :name="item.code">
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="right">
              <el-button class="add-btn" icon="el-icon-plus" @click="addItem" v-if="$route.meta.type === 'mine'">{{$t('complaintList.addComplaint')}}</el-button>
                <el-autocomplete
                    v-model="filterObj.issue"
                    :fetch-suggestions="function (queryString, cb) { return querySearchAsync(queryString, cb, 'issue') }"
                    :trigger-on-focus="false"
                    clearable
                    value-key="issue"
                    :placeholder="$t('complaintList.searchWorkOrder')"
                    @select="function (item) { return handleKeywordSelect(item, 'issue') }"
                    @keyup.enter.native="search"
                    >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    <button slot="append" class="search-btn" @click="search">{{$t('tagsView.search')}}</button>
                </el-autocomplete>
                <div class="advance-filter" @click="showDrawer">
                    <i class="iconfont icon-shaixuan"></i>
                    <span class="title">{{$t('complaintList.highSearch')}}</span>
                </div>
            </div>
        </div>
        <div class="empty_" v-if="!dataSource.length">
          <el-empty :description="$t('complaintList.noData')"></el-empty>
        </div>
        <div class="list" v-else>
          <div class="list-item"
          v-for="(item, idx) in dataSource"
          :key="idx"
          @click="toDetail(item)"
          >
            <div class="list-img" v-imagePreview>
              <img :src="item.photo" alt="" />
            </div>
            <div class="list-info">
              <div class="info-title">
                <span class="title">{{ item.complaintIssues ? item.complaintIssues : '--' }}</span>
                <el-tag
                :color="statusColorChange(item.status)"
                effect="dark"
                :style="{ borderColor: statusColorChange(item.status) }">
                {{ item.statusName }}
                </el-tag>
              </div>
              <div class="row">
               <div class="label">{{$t('complaintList.initiator')}}：</div>
               <div class="col">{{ item.name ? item.name : '--' }}</div>
              </div>
              <div class="row">
               <div class="label">{{$t('componentsReply.complaintObject')}}：</div>
               <div class="col">{{ item.complaintObject ? item.complaintObject : '--' }}</div>
              </div>
              <div class="row">
               <div class="label">{{$t('complaintList.complaintTime')}}：</div>
               <div class="col">{{ item.createTime ? item.createTime : '--' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination_">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listReq.current"
            :page-sizes="[9, 12, 18, 54]"
            :page-size="listReq.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listReq.total">
          </el-pagination>
        </div>
        <ComplainModal
        @updateList="getList"
        :defaultInfo="currentInfo"
        v-if="complainModalVisible"
        :visible.sync="complainModalVisible"
        />
        <Filterval :visible="visible" @close="close" :defaultList="defaultList" @submit="submit"/>
  </div>
</template>

<script>
import { getGenComplainPage, getShopComplainMinePage, getComplaintIssues, getFacComplainPage, getGenComplainMinePage } from "@/api/shopComplain"
import ComplainModal from "./components/modal/complain-reply"
import Filterval from '@/components/searchFilter.vue'
import website from "@/config/website";
import {

  generalItemShoppingcode,shopArchiveCode
} from "@/api/addDevice.js";
  export default {
    components: {
     ComplainModal,Filterval
    },
    data() {
      return {
        active: '0',
        loading: false,
        filterObj: {
          issue: '',
          serviceCode: '',
          complaintObject: ''
        },
        currentInfo: {
          linkUser:'',
          linkPhone:'',
          address:'',
          name:''
        },

        complainModalVisible: false,
        roleType: '',
        api: null,
        dataSource: [],
        searchList: [],
        visible: false,
        defaultList:[

          {name:this.$t('warehouseDetail.orderNum'),val:"serviceCode",url:'generalComplaintCodeList',option:'genoptions',label:'name'},
          {name:this.$t('componentsReply.complaintObject'),val:"complaintObject",url:'generalComplaintListComplaintObject',option:'bankoptions',label:'name'},
          {name:this.$t('logsIndex.time'),val:"timer",url:'',option:'',label:'',type:"time"},
        ],
        tabList: [
            {
              title: this.$t('applyChild.all'),
              code: '0',
            },
            {
              title: this.$t('complaintOrderDetail.toBeAccepted'),
              code: '1',
            },
            {
              title: this.$t('complaintOrderDetail.accepted'),
              code: '2',
            },
            {
              title: this.$t('complaintOrderDetail.pending'),
              code: '3',
            },
            {
              title: this.$t('complaintOrderDetail.replied'),
              code: '4',
            },
            {
              title: this.$t('complaintOrderDetail.completed'),
              code: '5',
            }
        ]
      }
    },
    computed: {
      listReq() {
        return {
          current: 1,
          size: 9,
          total: 0,
          status: this.active === '0' ? ' ' : this.active,
          complaintIssues: this.filterObj.issue,
          serviceCode: this.filterObj.serviceCode,
          complaintObject: this.filterObj.complaintObject
        }
      },
      type() {
        if(this.$route.meta && this.$route.meta.type) {
          return this.$route.meta.type;
        }
      },
      website() {
        return website
      }
    },
    created() {
      this.roleType = this.website.roleType
      console.log(this.roleType)
      console.log(this.$route.meta.type)
     this.getSearchList();
     this.getgeneralItemShoppingcode()
     this.getList();
    },
    methods: {
      showDrawer(){
        this.visible = true
      },
      submit(obj){
        console.log(obj)
        // this.searchobj = obj
        this.filterObj.serviceCode = obj.serviceCode
        this.filterObj.complaintObject = obj.complaintObject
        this.visible = false
        this.search()
      },
      close(){
        this.visible = false
      },
      async getgeneralItemShoppingcode() {
        const Api = this.roleType === 'shop' ? shopArchiveCode : generalItemShoppingcode
        try {
          const { data } = await Api()

          if (data.code === 200 && data.data) {
            const {
              userName: linkUser,
              userPhone: linkPhone,
              userAddress: address,
              shopName,
              generalName
            } = data.data

            Object.assign(this.currentInfo, {
              linkUser,
              linkPhone,
              address,
              name: shopName || generalName || ''
            })
          }
        } catch (err) {
          console.error('获取档案信息失败', err)
        }
      },
      statusColorChange(e) {
        switch(e) {
          case 1:
            return '#E5503C';
          case 2:
            return '#FD894A';
          case 5:
            return '#E6A23C';
          case 6:
            return '#67C23A';
          default:
            return '#50C4CB';
        }
      },
      handlePageApiChange(e) {
        console.log(e)
        switch(e) {
          case 'factory':
            return getFacComplainPage;
          case 'gen':
            return getGenComplainPage;

        }
      },
       handlePageTypeApi(e) {
        console.log(e)
        switch(e) {
          case 'shop':
            return getShopComplainMinePage;
          case 'gen':
            return getGenComplainMinePage;

        }
      },
      addItem() {
        this.complainModalVisible = true;
        this.currentInfo.modalType = 'mine';
        this.currentInfo.title = this.$t('complaintList.complaintAdd');
        this.currentInfo.roleType = this.roleType;
      },
      tabChange(tab, event) {
        let index = Number(tab.index);
        this.active = this.tabList[index].code;
        this.active = this.active == 5? '6' : this.active;

        this.getList();
      },
      querySearchAsync(queryString, cb, target) {
        var searchList = this.searchList;
        var results = queryString ? searchList.filter(this.createStateFilter(queryString, target)) : searchList;
        console.log(results);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 3000 * Math.random());
      },
      createStateFilter(queryString, target) {
        return (state) => {
            console.log(state);
          return (state[target].toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleKeywordSelect(item, key) {
        console.log(item[key]);
        this.filterObj[key] = item[key];
        this.getList();
      },
      search() {
        this.listReq.current = 1
        this.getList();
      },
      toDetail(item) {
        this.$router.push({
          path: `/service/complaintDetail`,
          query: {
            id: item.id,
            source: item.source
          }
        })
      },
      handleSizeChange(val) {
        console.log(this.$t('complaintList.everyPage')+ `${val}`+ this.$t('complaintList.bar'));
        this.listReq.size = val;
        this.getList();
      },
      handleCurrentChange(val) {
        console.log(this.$t('complaintList.momentPage')+`: ${val}`);
        this.listReq.current = val;
        this.getList();
      },
      async getSearchList() {
        try {
          const res = await getComplaintIssues({
            type: this.type === 'all' ? '0' : '1' // 0 投诉工单 1 我的投诉
          });
          console.log('search', res.data);
          if(res && res.data.code === 200) {
            let arr = [];
            res.data.data.map(x => {
              arr.push({
                issue: x
              })
            })
            this.searchList = arr;
          }
        } catch(e) {
          this.$message.error(e.toString())
        }
      },
      async getList() {
        try {
          console.log(this.type);
          this.loading = true;
          this.api = this.type === 'all' ? this.handlePageApiChange(this.roleType) : this.handlePageTypeApi(this.roleType);
          const res = await this.api(this.listReq);
          console.log(this.listReq,'----------');
          console.log('res =>', res.data);
          if(res.data && res.data.code === 200) {
            this.dataSource = res.data.data.records;
            this.listReq.total = res.data.data.total;
          }
          this.loading = false;
        } catch(e) {
          this.$message.error(e.toString())
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.container {
    background-color: #f0f2f5;
    height: 100%;
    overflow: auto;
}
.top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
    padding: 14px 23px;
    .right {
        display: flex;
        align-items: center;
        .add-btn {
          background-color: #50C4CB;
          color: #fff;
          margin-right: 58px;
        }
        .advance-filter {
            margin-left: 25px;
            white-space: nowrap;
            .title {
              margin-left: 8px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
            }
        }
        .search-btn {
            background: #50C4CB;
            border: none;
            color: #fff;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
        }
        .advance-filter:hover {
            cursor: pointer;
            color: #59CFD6;
        }
    }
}
.list {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  .list-item {
    display: flex;
    // width: 530px;
    padding: 10px 25px;
    background: #FFFFFF;
    box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
    // margin-bottom: 20px;
    border-radius: 4px;
    .list-img {
      width: 160px;
      min-height: 140px;
      max-height: 165px;
      margin: auto 0;
      & > img {
        width: 100%;
        height: 100%;
      }
      -webkit-filter: drop-shadow(5px 5px 5px rgba(0,0,0,.5));
      filter: drop-shadow(5px 5px 5px rgba(0,0,0,.5));
    }
    .list-info {
      margin-left: 24px;
      flex: 1;
    }
    .info-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .title {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
      .title:hover {
        text-decoration: underline;
      }
      .status {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        // color: #E5503C;
      }
    }
    .row {
      display: flex;
      align-items: center;
      margin-bottom: 22px;
    }
    .label {
      min-width: 15%;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
    .col {
      flex: 1;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }
  }
  .list-item:hover {
    cursor: pointer;
  }
}
.pagination_ {
    position: fixed;
    right: 23px;
    bottom: 24px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #50C4CB;
}
/deep/ .el-tabs__item.is-active {
    color: #50C4CB;
}
/* 去除下方横线 */
/deep/ .el-tabs__nav-wrap::before {
  content: '';
  width: 0 !important;
}
/deep/ .el-tabs__nav-wrap::after {
  content: '';
  width: 0 !important;
}
/deep/ .el-tabs__header {
  margin: 0;
}
/deep/ .el-tabs__item {
  font-size: 16px;
  color: #333333;
  font-weight: 400;
  font-family: Source Han Sans CN;
}
/deep/ .el-tabs__active-bar {
    background-color: #50C4CB;
}
/deep/ .el-autocomplete input {
    border-color: #50C4CB;
}
/deep/ .el-input-group__append {
    background-color: #50C4CB;
}
</style>
